import { render, staticRenderFns } from "./switch1.vue?vue&type=template&id=27accab0&scoped=true&"
import script from "./switch1.vue?vue&type=script&lang=js&"
export * from "./switch1.vue?vue&type=script&lang=js&"
import style0 from "./switch1.vue?vue&type=style&index=0&id=27accab0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27accab0",
  null
  
)

export default component.exports